import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable array-callback-return */

/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-shadow */

import React, { useEffect, useState } from "react"; // import { Tag, TextareaItem } from "antd-mobile";

import { Input, Tag } from "antd";
import "../index.less";
var TextArea = Input.TextArea;
var CheckableTag = Tag.CheckableTag;
var emotionList = [{
  value: 1,
  url: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/37b7d_20220425160728.png',
  selectedUrl: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/be679_20220425160556.png',
  desc: '非常不满意'
}, {
  value: 2,
  url: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/fff2f_20220425160741.png',
  selectedUrl: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/bce90_20220425160631.png',
  desc: '不满意'
}, {
  value: 3,
  url: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/d4744_20220425160756.png',
  selectedUrl: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/7026a_20220425160645.png',
  desc: '一般'
}, {
  value: 4,
  url: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/c050e_20220425160812.png',
  selectedUrl: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/23504_20220425160703.png',
  desc: '满意'
}, {
  value: 5,
  url: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/131b7_20220425160824.png',
  selectedUrl: 'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/25/40615_20220425160715.png',
  desc: '非常满意'
}];

var EvaluationQuestion = function EvaluationQuestion(props) {
  var questionItem = props.questionItem,
      readlyQuestionItem = props.readlyQuestionItem,
      _props$firstClickInde = props.firstClickIndex,
      firstClickIndex = _props$firstClickInde === void 0 ? -1 : _props$firstClickInde;

  var _useState = useState(firstClickIndex - 1),
      _useState2 = _slicedToArray(_useState, 2),
      selectedEmo = _useState2[0],
      setSelectedEmo = _useState2[1]; // 选中的评分


  var _useState3 = useState(firstClickIndex > 0 && questionItem ? {
    questionId: questionItem.questionId,
    score: firstClickIndex
  } : null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedQuestion = _useState4[0],
      setSelectedQuestion = _useState4[1]; // 选中的评分
  // eslint-disable-next-line no-nested-ternary


  var _useState5 = useState(readlyQuestionItem ? emotionList[readlyQuestionItem.score - 1].desc : firstClickIndex > 0 && questionItem ? emotionList[firstClickIndex - 1].desc : ''),
      _useState6 = _slicedToArray(_useState5, 2),
      selectEmotionDesc = _useState6[0],
      setSelectEmotionDesc = _useState6[1]; // 显示表情描述


  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      tagList = _useState8[0],
      setTagList = _useState8[1]; // 问题列表


  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      textAre = _useState10[0],
      setTextaAre = _useState10[1]; // 问题列表


  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isShowTextAre = _useState12[0],
      setTextAreShow = _useState12[1];

  var onSelected = function onSelected(item, index) {
    var itemData = {
      questionId: item.questionId,
      score: index + 1 // 类型：Number  可有字段  备注：评分

    };
    console.log("🚀 ~ file: evaluation-question.tsx ~ line 70 ~ onSelected ~ itemData", itemData);
    setSelectedQuestion(itemData);
  };

  useEffect(function () {
    if (questionItem && firstClickIndex !== -1) {
      props.onSelectedItem && props.onSelectedItem(selectedQuestion);
    }
  }, []);

  var getQuestionEmotion = function getQuestionEmotion(questionItem) {
    var option = questionItem.options || [];
    var part = selectedEmo !== -1 ? option[selectedEmo] && option[selectedEmo].part || [] : [];
    return /*#__PURE__*/React.createElement("div", {
      className: "evaluationPage"
    }, /*#__PURE__*/React.createElement("div", {
      className: "emotion-rate"
    }, emotionList && emotionList.map(function (i, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row-emotion",
        key: JSON.stringify(i) + index,
        onClick: function onClick() {
          setSelectEmotionDesc(i.desc);
          setSelectedEmo(index);
          onSelected(questionItem, index);
          setTextAreShow(false);
          setTagList([]);
          props.onSelectedItem && props.onSelectedItem({
            questionId: questionItem.questionId,
            score: index + 1
          });
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: selectedEmo === index ? i.selectedUrl : i.url,
        width: 32
      }));
    }), /*#__PURE__*/React.createElement("div", {
      className: "rate-desc"
    }, selectEmotionDesc)), /*#__PURE__*/React.createElement("div", {
      className: "row-content"
    }, part.map(function (i, idx) {
      return i.option ? /*#__PURE__*/React.createElement(CheckableTag, {
        className: "service-btn",
        key: idx,
        checked: tagList.includes(idx),
        onChange: function onChange(e) {
          var newList = [];

          if (e) {
            i.isOther === 1 && setTextAreShow(true);
            tagList.push(idx);
            newList = _toConsumableArray(tagList);
          } else {
            i.isOther === 1 && setTextAreShow(false);
            tagList.map(function (item) {
              if (item !== idx) {
                newList.push(item);
              }
            });
          }

          setTagList(newList);
          var itemParts = newList.map(function (selIndex) {
            var item = part[selIndex];
            return item.isOther !== 1 ? {
              clickOptionId: part[selIndex].optionId,
              isOther: part[selIndex].isOther
            } : {
              clickOptionId: part[selIndex].optionId,
              isOther: part[selIndex].isOther,
              remark: textAre
            };
          });
          selectedQuestion.optionPart = itemParts;
          props.onSelectedItem && props.onSelectedItem(selectedQuestion);
        }
      }, i.option) : '';
    })), isShowTextAre && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, {
      placeholder: "",
      rows: 2,
      maxLength: 100,
      value: textAre,
      onChange: function onChange(e) {
        var value = e.target.value;
        selectedQuestion.optionPart.map(function (item) {
          if (item.isOther === 1) {
            item.remark = value;
          }
        });
        props.onSelectedItem && props.onSelectedItem(selectedQuestion);
        setTextaAre("".concat(value));
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "item-text-number"
    }, /*#__PURE__*/React.createElement("span", {
      className: textAre.length > 100 ? 'text-number-red' : 'text-number-span'
    }, textAre.length), "/100")));
  };

  var getQuestionEmotionReadly = function getQuestionEmotionReadly(questionItem) {
    var studentEvaluationClickOptionList = questionItem.studentEvaluationClickOptionList,
        score = questionItem.score;
    return /*#__PURE__*/React.createElement("div", {
      className: "evaluationPage"
    }, /*#__PURE__*/React.createElement("div", {
      className: "emotion-rate"
    }, emotionList && emotionList.map(function (i, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row-emotion",
        key: JSON.stringify(i) + index
      }, /*#__PURE__*/React.createElement("img", {
        src: score === index + 1 ? i.selectedUrl : i.url,
        width: 32
      }));
    }), /*#__PURE__*/React.createElement("div", {
      className: "rate-desc"
    }, selectEmotionDesc)), studentEvaluationClickOptionList && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row-content"
    }, studentEvaluationClickOptionList.map(function (item, idx) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckableTag, {
        className: "service-btn",
        key: idx,
        checked: true
      }, item.option), item.remark && /*#__PURE__*/React.createElement("div", {
        className: "content-remake"
      }, item.remark));
    }))));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, questionItem && getQuestionEmotion(questionItem), readlyQuestionItem && getQuestionEmotionReadly(readlyQuestionItem));
};

export default EvaluationQuestion;